import { Link } from "react-router-dom";

interface DramaCardProps {
  to: string;
  cover: string;
  title: string;
  genre?: string;
  year?: number | string;
  rating?: number;
  duration?: string;
  summary?: string;
}

export default function DramaCard({ to, cover, title, genre, year, rating, duration, summary }: DramaCardProps) {
  return (
    <Link
      to={to}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={cover}
          alt={`善良的小姨子相关推荐剧集《${title}》封面`}
          title={`${title} 剧集封面`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {typeof rating === "number" && (
          <span className="absolute top-2 left-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-secondary-500 text-secondary-950 text-xs font-bold">
            <i className="ri-star-fill text-[11px]"></i>
            {rating.toFixed(1)}
          </span>
        )}
        <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/40 transition-colors flex items-center justify-center">
          <span className="w-11 h-11 rounded-full bg-accent-500 text-background-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <i className="ri-play-fill text-xl"></i>
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h4 className="font-heading text-sm md:text-base font-bold text-foreground-950 truncate">{title}</h4>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          {genre && <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900">{genre}</span>}
          {year && <span>{year}</span>}
          {duration && <span className="truncate">{duration}</span>}
        </div>
        {summary && <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">{summary}</p>}
      </div>
    </Link>
  );
}